import React, { useState } from 'react';
import ErrorMessageContext from './ErrorMessageContext';

const ErrorMessageProvider = ({ children }) => {
  const [state, setState] = useState({
    errorMessages: new Set(), // use of new Set to avoid double display of error in data-country, data-theme, data-provider
    showErrorMessage: false,
  });

  // Function to add error message
  const addErrorMessage = (errorMessage) => {
    setState((prevState) => ({
      ...prevState,
			errorMessages: new Set([...prevState.errorMessages, errorMessage]),
			showErrorMessage: true,
    }));
  };

  // Function to clear all error messages after clicking on X
  const clearErrorMessages = () => {
    setState((prevState) => ({
      ...prevState,
      showErrorMessage: false,
			errorMessages: new Set(),
    }));
  };

  return (
    <ErrorMessageContext.Provider value={{ ...state, addErrorMessage, clearErrorMessages }}>
      {children}
    </ErrorMessageContext.Provider>
  );
}

export default ErrorMessageProvider;

